import { useEffect, useState } from "react";
import { Button, Empty, Popconfirm, Select, Spin } from "antd";
import { chatService } from "../../services/resources/chatService";
import { openNotification } from "../Notification";
import { ChatLiberacoesLista } from "./ChatLiberacoesLista";
import { paginaAjustadaLiberacao } from "./chatLiberacoesPaginacao";

export const ChatLiberacoesInstituicoes = () => {
  const [instituicoes, setInstituicoes] = useState([]);
  const [liberacoes, setLiberacoes] = useState([]);
  const [instituicaoA, setInstituicaoA] = useState();
  const [instituicaoB, setInstituicaoB] = useState();
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [salvandoTodos, setSalvandoTodos] = useState(false);

  async function carregar(paginaDesejada) {
    try {
      const [{ data: listaInstituicoes }, { data: listaLiberacoes }] =
        await Promise.all([
          chatService.listarInstituicoes(),
          chatService.listarLiberacoesInstituicao(),
        ]);
      const lista = listaLiberacoes || [];
      setInstituicoes(listaInstituicoes || []);
      setLiberacoes(lista);
      setPagina((atual) =>
        paginaAjustadaLiberacao(lista.length, paginaDesejada ?? atual)
      );
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível carregar as liberações de instituições</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    carregar();
  }, []);

  async function conceder() {
    if (!instituicaoA || !instituicaoB) return;
    setSalvando(true);
    try {
      await chatService.concederLiberacaoInstituicao(instituicaoA, instituicaoB);
      setInstituicaoA(undefined);
      setInstituicaoB(undefined);
      await carregar(1);
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível liberar as instituições</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setSalvando(false);
    }
  }

  async function concederTodos() {
    setSalvandoTodos(true);
    try {
      const { data } = await chatService.concederLiberacaoTodos();
      openNotification(
        "success",
        <strong>Instituições liberadas</strong>,
        `${data?.quantidade || 0} par(es) entre instituições ativas`
      );
      await carregar(1);
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível liberar para todos</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setSalvandoTodos(false);
    }
  }

  async function desativar(codigo) {
    try {
      await chatService.desativarLiberacaoInstituicao(codigo);
      await carregar();
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível desativar a liberação</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    }
  }

  async function ativar(codigo) {
    try {
      await chatService.ativarLiberacaoInstituicao(codigo);
      await carregar();
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível ativar a liberação</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    }
  }

  const opcoes = instituicoes.map((item) => ({
    value: item.codigo,
    label: item.nome,
  }));

  return (
    <section>
      <h3 className="chat-liberacoes__titulo">Instituições</h3>
      <div className="chat-liberacoes__form">
        <Select
          showSearch
          allowClear
          loading={carregando}
          placeholder="Instituição A"
          value={instituicaoA}
          options={opcoes.filter((item) => item.value !== instituicaoB)}
          optionFilterProp="label"
          onChange={setInstituicaoA}
        />
        <Select
          showSearch
          allowClear
          loading={carregando}
          placeholder="Instituição B"
          value={instituicaoB}
          options={opcoes.filter((item) => item.value !== instituicaoA)}
          optionFilterProp="label"
          onChange={setInstituicaoB}
        />
        <div className="chat-liberacoes__acoes">
          <Button
            type="primary"
            loading={salvando}
            disabled={carregando || !instituicaoA || !instituicaoB}
            onClick={conceder}
          >
            Liberar instituições
          </Button>
          <Popconfirm
            title="Liberar o diálogo entre todas as instituições ativas?"
            okText="Liberar"
            cancelText="Cancelar"
            onConfirm={concederTodos}
            disabled={carregando}
          >
            <Button loading={salvandoTodos} disabled={carregando}>
              Liberar para todos
            </Button>
          </Popconfirm>
        </div>
      </div>
      {carregando ? (
        <div className="chat-vazio" role="status" aria-live="polite">
          <Spin />
        </div>
      ) : !liberacoes.length ? (
        <div className="chat-vazio">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhuma liberação entre instituições"
          />
        </div>
      ) : (
        <ChatLiberacoesLista
          itens={liberacoes}
          pagina={pagina}
          onPagina={setPagina}
          rotulo={(item) => `${item.instituicaoA?.nome} ↔ ${item.instituicaoB?.nome}`}
          onAtivar={ativar}
          onDesativar={desativar}
        />
      )}
    </section>
  );
};
